import React from 'react';

interface IconProps {
  fill?: string;
  height?: string | number;
  width?: string | number;
}

export function FileIcon({ fill = '#D9D9D9', width = 25, height = 25 }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 25 25">
      <g clipPath="url(#clip0_2487_9951)">
        <path
          fill={fill}
          d="M14.585 2.083H6.25a2.08 2.08 0 00-2.073 2.083l-.01 16.667a2.08 2.08 0 002.073 2.083h12.51a2.09 2.09 0 002.084-2.083v-12.5l-6.25-6.25zm4.166 18.75h-12.5V4.166h7.292v5.209h5.208v11.458zM8.335 15.635l1.468 1.469 1.657-1.646v4.333h2.083v-4.333l1.656 1.656 1.469-1.479-4.156-4.177-4.177 4.177z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2487_9951">
          <path fill="#fff" d="M0 0H25V25H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
